<div id="personalize-dialog">
<acc-common-personalize [mainCartId]="data.mainCartId" [quoteId]="data.quoteId" (onClose)="close($event)" [onFileAdded]="fileAdded.asObservable()" (onShowSelectFile)="showSelectFile()" [defaultMessage]="data.message"></acc-common-personalize>
</div>